export const QUESTION_FORM = 'question-form';
export const NAME_FORM = 'name-form';
export const RATING_CONTACT_FOLLOW_UP = 'rating-contact-follow-up';
export const RATING_CONTACT_FOLLOW_UP_CHALLENGE = 'rating-contact-follow-up-challenge';
export const RATING_CONTACT_FOLLOW_UP_CHAT_ONLY = 'rating-contact-follow-up-chat-only';
export const RATING_CONTACT_FOLLOW_UP_QUESTION_ONLY = 'rating-contact-follow-up-question-only';
export const FEEDBACK_REQUEST = 'feedback-request';

export const FORM_IDS = {
  QUESTION_FORM,
  NAME_FORM,
  RATING_CONTACT_FOLLOW_UP,
  RATING_CONTACT_FOLLOW_UP_CHALLENGE,
  RATING_CONTACT_FOLLOW_UP_CHAT_ONLY,
  RATING_CONTACT_FOLLOW_UP_QUESTION_ONLY,
  FEEDBACK_REQUEST,
} as const;

export const DEFAULT_ERROR_MESSAGE = 'Something went wrong';
